// angular
import { Injectable, inject } from '@angular/core';
import { Socket, SocketIoConfig } from 'ngx-socket-io';
// services
import { StorageService } from './storage.service';
// env
import { environment } from '@environments/environment';

@Injectable()
export class SocketFactory {
  private sockets: Map<string, Socket> = new Map();

  // dependencies
  private readonly _storageService = inject(StorageService);
  constructor() {}

  getSocket(namespace: string): Socket {
    const token = this._storageService.getToken();
    const chat_id = this._storageService.getChatId();
    const member_id = this._storageService.getMemberId();
    const lang = this._storageService.getChatLang();

    if (this.sockets.has(namespace)) {
      return this.sockets.get(namespace)!;
    }

    const config: SocketIoConfig = {
      url: `${environment.baseUrl.socket}${namespace}`,
      options: {
        transports: ['websocket'],
        autoConnect: true,
      } as any,
    };

    if (token) {
      (config.options as any).auth = {
        token,
      };

      (config.options as any).query = {
        lang,
        project: 'wejoner',
      };
    } else if (chat_id) {
      (config.options as any).query = {
        chat_id,
        member_id,
        lang,
        is_guest: true,
        project: 'wejoner',
      };
    }

    const socket = new Socket(config);
    this.sockets.set(namespace, socket);
    return socket;
  }

  disconnectAll() {
    this.sockets.forEach(socket => {
      socket.disconnect();
    });
    this.sockets.clear();
  }
}
